module.exports = __webpack_public_path__ + "img/ArgosShoplogo.fba7e454.svg";